import Handlebars from 'handlebars';
import i18next from 'i18next';
import {
  signatureTemplate,
  missedSweepSignatureTemplate,
  sweepViewPlayerTableTemplate,
} from '@inplay/models';

// Use isolated instance to avoid polluting global Handlebars
const hbs = Handlebars.create();
hbs.registerHelper('t', (key: string) => (i18next.t as any)(key));

const templates = {
  signature: signatureTemplate,
  missedSweep: missedSweepSignatureTemplate,
  playerTable: sweepViewPlayerTableTemplate,
} as const;

export type SweepTemplateType = keyof typeof templates;

export const renderSweepTemplate = (
  type: SweepTemplateType,
  data: Record<string, unknown>,
): string => {
  const compiled = hbs.compile(templates[type]);
  return compiled(data);
};
